import React from "react";
import { Col, Row } from "react-bootstrap";
import "../../Assets/Styles/pages/landing.scss";
import rightArrow from "../../Assets/Images/rightArrow.svg";
import { useTranslation } from "react-i18next";
import LottiePlayer from "../LottiePlayer/lottiePlayer";
import ButtonRounded from "../Signature/button";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const PlanCards = ({ plan, classes, arrow = false }) => {
  const { t } = useTranslation();

  const history = useHistory();
  return (
    <Row className="w-25 w-xs-100 px-3 h-100 h-xs-25 text-black mx-2">
      <Col
        className={`w-100 planCard rounded ${
          classes + "Card"
        } m-4 m-lg-0 cardStyle`}
      >
        <Row className="cardStyle1 rounded position-relative  h-100 ">
          {plan.recommended ? (
            <Row className="d-flex justify-content-center line_height_1 align-items-center text-white text-uppercase productSansBold recommendedCard m-0 p-0 rounded-top text_11">
              {"Recommened"}
            </Row>
          ) : null}
          <Col className={`px-4  d-flex flex-column`}>
            <Row className="mx-2 d-flex justify-content-between position-relative">
              <Col className={`m-0 p-0  pt-4 mt-2 p-0`}>
                <Row
                  className={`m-0 p-0 productSansBold text_18 ${
                    classes + "CardTitle"
                  }`}
                >
                  {t(plan.title)}
                </Row>
                <Col
                  className={` ${
                    plan.recommended ? "linedThrough" : ""
                  } py-2 m-0 h-25  p-0 productSansBold text_32 d-flex align-items-center`}
                >
                  <span className={` ${plan.recommended && "linedThrough"} `}>
                    {plan.price}
                  </span>
                  <span
                    className={`mx-1 mb-1 ${
                      plan.recommended && "linedThrough"
                    } Aktiv_Medium text_11`}
                  >
                    {"$/month"}
                  </span>
                </Col>
                {plan.recommended ? (
                  <span className="m-0 ms-1 mt-1 w_150 d-flex productSansMedium betaColor text_11 p-0">
                    {t("betaVersion")}
                  </span>
                ) : (
                  <span className="m-0 ms-1 mt-1 w_150 d-flex productSansMedium invisible betaColor text_11 p-0">
                    {t("betaVersion")}
                  </span>
                )}
              </Col>
              <Col
                xs={plan.recommended ? 6 : classes === "enterprise" ? 3 : 3}
                className="p-0 planIcons"
              >
                <LottiePlayer src={plan.animation} />
              </Col>
            </Row>

            <Row className="mx-2 productSansLight text_15">
              <ul className={`custom-list ${classes + "Tick"}  p-0 m-0`}>
                {plan &&
                  plan.bullets?.map((bullet, i) => {
                    return (
                      <li
                        key={i}
                        className={`${plan.recommended ? "mb-2" : "mb-2"} ps-4`}
                      >
                        {t(bullet)}
                      </li>
                    );
                  })}
              </ul>
            </Row>
            <Col className=" py-4 d-flex align-items-end justify-content-center">
              {classes === "free" ? (
                <ButtonRounded
                  onclick={() => {
                    // Detect user's operating system
                    var userAgent =
                      navigator.userAgent || navigator.vendor || window.opera;
                    var isIOS =
                      /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
                    var isAndroid = /Android/.test(userAgent);

                    // Redirect to app store based on operating system
                    if (isIOS) {
                      window.location.href =
                        "https://apps.apple.com/us/app/ezy-watermark-photos-lite/id494473910";
                    } else if (isAndroid) {
                      window.location.href =
                        "https://play.google.com/store/apps/details?id=com.whizpool.ezywatermarklite";
                    } else {
                      history.push("/home");
                    }
                  }}
                  text={t("GetStarted")}
                  style={`w_edit_button ${
                    "planButton_" + classes
                  } planButton my-2 mb-3  py-2 mb-0 p-0`}
                  arrow={arrow && rightArrow}
                  parrentStyle={"w-50"}
                />
              ) : (
                <ButtonRounded
                  text={t("Purchase")}
                  style={`w_edit_button ${
                    "planButton_" + classes
                  } planButton my-2 mb-3  py-2 mb-0 p-0`}
                  arrow={arrow && rightArrow}
                  parrentStyle={"w-50"}
                />
              )}
            </Col>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default PlanCards;
